import SampleMasterScreen from "components/modules/sample-module/masters/SampleMasterScreen";
import SampleMasterScreenTabbed from "components/modules/sample-module/masters/SampleMasterScreenTabbed";
import EngagementTypeMasterScreen from "components/modules/engagement-type/masters/EngagementTypeMasterScreen";
import ActivityMasterScreen from "components/modules/activity/masters/ActivityMasterScreen";
import ClientTypeMasterScreen from "components/modules/client-type/masters/ClientTypeMasterScreen";
import RegistrationTypeMasterScreen from "components/modules/registration-type/masters/RegistrationTypeMasterScreen";
import ClientRegistrationRegisterScreen from "components/modules/client-registration/registers/ClientRegistrationRegisterScreen";
import DesignationMasterScreen from "components/modules/designation/masters/DesignationMasterScreen";
import OfficeMasterScreen from "components/modules/office/masters/OfficeMasterScreen";
import ClientGroupMasterScreen from "components/modules/client-group/masters/ClientGroupMasterScreen";
import EmployeeMasterScreen from "components/modules/employee/masters/EmployeeMasterScreen";
import HolidayMasterScreen from "components/modules/holiday/masters/HolidayMasterScreen";
import ClientMasterScreen from "components/modules/client/masters/ClientMasterScreen";
import EngagementMasterScreen from "components/modules/engagement/masters/EngagementMasterScreen";
import DisbursementMasterScreen from "components/modules/disbursement/masters/DisbursementMasterScreen";
import TimesheetMasterScreen from "components/modules/timesheet/masters/TimesheetMasterScreen";
import EmployeeActivityReportScreen from "components/modules/reports/EmployeeActivityReportScreen";
import WipReportScreen from "components/modules/reports/WipReportScreen";
import TimesheetStatusReportScreen from "components/modules/reports/TimesheetStatusReportScreen";
import ManagerDashboardScreen from "components/modules/dashboard/ManagerDashboardScreen";
import RolePermissionScreen from "components/modules/admin-module/masters/RolePermissionScreen";
import ConfigSettingsScreen from "components/modules/config/ConfigSettingsScreen";
import FsaTemplateMasterScreen from "components/modules/fsa/templates/FsaTemplateMasterScreen";
import FsaEngagementListScreen from "components/modules/fsa/engagement/FsaEngagementListScreen";
import FsaEngagementScreen from "components/modules/fsa/engagement/FsaEngagementScreen";
import FsaAuditFirmMasterScreen from "components/modules/fsa/signature/FsaAuditFirmMasterScreen";
import FsaAuditPartnerMasterScreen from "components/modules/fsa/signature/FsaAuditPartnerMasterScreen";
import FsaDirectorSignatoryMasterScreen from "components/modules/fsa/signature/FsaDirectorSignatoryMasterScreen";
import FsaPartnerMasterScreen from "components/modules/fsa/signature/FsaPartnerMasterScreen";
import FsaDocumentOutputSettingsScreen from "components/modules/fsa/settings/FsaDocumentOutputSettingsScreen";
// GST module — Slice 0 skeleton (ADR-0008). Replaced by the Filing Dashboard in G-1.
import GstModuleInfoScreen from "components/modules/gst/GstModuleInfoScreen";
import GstEngagementListScreen from "components/modules/gst/GstEngagementListScreen";
import GstExtensionsScreen from "components/modules/gst/GstExtensionsScreen";
import GstTurnoverScreen from "components/modules/gst/GstTurnoverScreen";
// Firm-wide compliance calendar — cross-module, NOT a GST screen (ADR-0020 §5).
import ComplianceCalendarScreen from "components/modules/compliance/ComplianceCalendarScreen";

export const COMPONENT_REGISTRY: Record<string, React.ComponentType<any>> = {
  SampleMasterScreenTabbed: SampleMasterScreenTabbed,
  SampleMasterScreen: SampleMasterScreen,
  // PRIMA masters
  EngagementTypeMasterScreen: EngagementTypeMasterScreen,
  ActivityMasterScreen: ActivityMasterScreen,
  ClientTypeMasterScreen: ClientTypeMasterScreen,
  RegistrationTypeMasterScreen: RegistrationTypeMasterScreen,
  ClientRegistrationRegisterScreen: ClientRegistrationRegisterScreen,
  DesignationMasterScreen: DesignationMasterScreen,
  OfficeMasterScreen: OfficeMasterScreen,
  ClientGroupMasterScreen: ClientGroupMasterScreen,
  EmployeeMasterScreen: EmployeeMasterScreen,
  HolidayMasterScreen: HolidayMasterScreen,
  ClientMasterScreen: ClientMasterScreen,
  EngagementMasterScreen: EngagementMasterScreen,
  DisbursementMasterScreen: DisbursementMasterScreen,
  TimesheetMasterScreen: TimesheetMasterScreen,
  // PRIMA reports & dashboard
  EmployeeActivityReportScreen: EmployeeActivityReportScreen,
  WipReportScreen: WipReportScreen,
  TimesheetStatusReportScreen: TimesheetStatusReportScreen,
  ManagerDashboardScreen: ManagerDashboardScreen,
  // Admin
  RolePermissionScreen: RolePermissionScreen,
  // Config
  ConfigSettingsScreen: ConfigSettingsScreen,
  // FSA module — Stage 1: read-only template browser
  FsaTemplateMasterScreen: FsaTemplateMasterScreen,
  // GST module — Slice 0 walking skeleton
  GstModuleInfoScreen: GstModuleInfoScreen,
  GstEngagementListScreen: GstEngagementListScreen,
  GstExtensionsScreen: GstExtensionsScreen,
  GstTurnoverScreen: GstTurnoverScreen,
  // Compliance — firm-wide, reads prima.tbl_obligation across every module
  ComplianceCalendarScreen: ComplianceCalendarScreen,
  // FSA module — Stage 2.1: list of engagements with FSA configured
  FsaEngagementListScreen: FsaEngagementListScreen,
  // FSA module — Stage 2.1: per-engagement workspace
  FsaEngagementScreen: FsaEngagementScreen,
  // FSA module — Stage 2.3 Signature Workflow: audit firm master
  FsaAuditFirmMasterScreen: FsaAuditFirmMasterScreen,
  // FSA module — Stage 2.3 Signature Workflow: audit partner roster
  FsaAuditPartnerMasterScreen: FsaAuditPartnerMasterScreen,
  // FSA module — Stage 2.3 Signature Workflow: director / signatory roster
  FsaDirectorSignatoryMasterScreen: FsaDirectorSignatoryMasterScreen,
  // FSA module — NCP-13/14: partner master (partnership firms)
  FsaPartnerMasterScreen: FsaPartnerMasterScreen,
  // FSA module — Document Output Settings (ADR-0003)
  FsaDocumentOutputSettingsScreen: FsaDocumentOutputSettingsScreen,
  // Add more components here as you create them:
  // UserManagement: UserManagementScreen,
};